/**
 * STAGE 4 — Custom hook
 * ---------------------
 * Encapsulates: "If app data isn't in Redux yet, fetch it once."
 * NavBar / bootstrap call this instead of duplicating useEffect + API logic.
 */
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAppData } from '../redux/features/common/commonSlice'
import {
  selectIsAppDataLoaded,
  selectAppDataLoading
} from '../redux/features/common/selectors'

export const useEnsureAppData = () => {
  const dispatch = useDispatch()
  const isLoaded = useSelector(selectIsAppDataLoaded)
  const loading = useSelector(selectAppDataLoading)

  useEffect(() => {
    if (!isLoaded && !loading) {
      dispatch(fetchAppData())
    }
  }, [dispatch, isLoaded, loading])

  return { isLoaded, loading }
}
